import React from 'react';
import './PricingPlans.css';
import { useNavigate } from 'react-router-dom';

const PricingPlans = () => {
  const navigate = useNavigate();
  const plans = [
    {
      num: "01",
      name: "Residential",
      price: "499",
      theme: "vps-pink",
      features: [
        { text: "Residential & Commercial Architectural planning ", included: true },
        { text: "Structural design", included: true },
        { text: "Construction Phase [start to finish]", included: true },
        { text: "Finishing & Handover", included: true },
      ]
    },
    {
      num: "02",
      name: "Commercial",
      price: "899",
      theme: "vps-pink",
      features: [
        { text: "Site Engineering & Design", included: true },
        { text: "Reinforced Concrete Works", included: true },
        { text: "Electrical & Plumbing Setup", included: true },
        { text: "Landscape & External Works", included: false },
        
      ]
    },
    {
      num: "03",
      name: "Industrial",
      price: "1299",
      theme: "vps-pink",
      features: [
        { text: "Site Visit", included: true },
        { text: "Planning & Budget", included: true },
        { text: "Execution (old to new)", included: true },
        { text: "Daily Monitoring,Finishing & Handover", included: true },
        
      ]
    }
  ];

  return (
    <section className="pricing-section py-5">
      <div className="container py-5">
        <div className="row g-5 justify-content-center">
          {plans.map((plan, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className={`plan-card ${plan.theme}`}>
                {/* Numbered Circle sit on top center */}
                {/* <div className="top-badge">{plan.num}</div> */}
                
                <div className="plan-header">
                  <div className="label-ribbon">
                    <span>{plan.name}</span>
                  </div>
                  <div className="price-tag">
                    <span className="currency"> {plan.name}</span>
                    <span className="amount"></span>
                    <span className="cents"></span>
                  </div>
                </div>

                <div className="plan-body">
                  <ul className="feature-list">
                    {plan.features.map((feat, i) => (
                      <li key={i} className={feat.included ? "active" : "inactive"}>
                        <i className={`bi ${feat.included ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
                        {feat.text}
                      </li>
                    ))}
                  </ul>
                  <button className="select-btn" onClick={() => navigate("/contact")}>Get a Quote</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;